var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TeaserAccountTile',[_c('template',{slot:"component"},[_c('cp-account-customer-activation')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }